export default function() {
    // Accordions
    // Used globally on mobile navigation, footer and accordion block
    // If there is an accordion inside an accordion then data-accordion-allow-multiple needs to be used
    const forms = document.querySelectorAll('section.form-block form');

    if (forms.length) {
        forms.forEach(function(form) {
            // add event listener to the submit button; change the label to "Sending..."

            const submitButton = form.querySelector('button[type="submit"]');
            const isRegistrationForm = submitButton.innerHTML === 'Notify me';

            submitButton.addEventListener('click', function(e) {
                let formIsValid = true;

                if (isRegistrationForm) {
                    submitButton.innerHTML = 'Sending...';
                } else {
                    submitButton.innerHTML = 'Submitting...';
                }

                // check if the fields from the form are valid
                const formFields = form.querySelectorAll('input, textarea');

                formFields.forEach(function(field) {
                    let label = field.nextElementSibling;
                    if (label) {
                        label.classList.remove('error');
                    }
                    field.classList.remove('error');


                    if (!field.checkValidity()) {
                        formIsValid = false;
                        field.classList.add('error');

                        if (label && label.classList) {
                            label.classList.add('error');
                        }
                    }
                });

                if (formIsValid === false) {
                    if(isRegistrationForm) {
                        submitButton.innerHTML = 'Notify me';
                    } else {
                        submitButton.innerHTML = 'Submit';
                    }

                    form.classList.add('form-block--error');
                } else {
                    form.classList.remove('form-block--error');
                }

            });

            if (isRegistrationForm) {
                form.addEventListener('submit', function(e) {
                    e.preventDefault();

                    let formData = new FormData(form);
                    let thanksMessage = document.querySelector('section.form-block #thanks');
                    thanksMessage.classList.add('hidden');
                    thanksMessage.classList.remove('fade-in');

                    const serializedData = Array.from(formData, x =>
                            x.map(encodeURIComponent).join('=')
                        ).join('&');

                    fetch('/', {
                        method: 'POST',
                        body: new URLSearchParams(serializedData),
                        headers: {
                            'Accept': 'application/json'
                        }
                    })
                        .then(response => {
                            thanksMessage.classList.remove('hidden');
                            thanksMessage.classList.add('fade-in');
                            submitButton.innerHTML = 'Notify me';
                            form.querySelector('input[type="email"]').value = '';

                            return response.json();
                        })
                        .then(data => {
                            console.log(data);
                        });
                } );
            }

        });
    }

}